import { render, staticRenderFns } from "./FangAn.vue?vue&type=template&id=31dcd855&scoped=true&"
import script from "./FangAn.vue?vue&type=script&lang=js&"
export * from "./FangAn.vue?vue&type=script&lang=js&"
import style0 from "./FangAn.vue?vue&type=style&index=0&id=31dcd855&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dcd855",
  null
  
)

export default component.exports